import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { getDataApi1, loadApi, saveApi, loadApi1, saveApi1} from "../services/appApi";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const W2s  = () => {

  let emptyRow = {
    business_dba_name: null,
    business_email_address: null,
    business_federal_tax_id: null,
    business_legal_name: null,
    business_phone_number: null,
    client_contact_cell_phone: null,
    client_contact_email_address: null,
    client_contact_home_phone: null,
    client_contact_work_phone: null,
    client_federal_tax_id: null,
    client_federal_tax_id_type: "",
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_type_desc: null,
    client_type_lkcd: "",
    client_type_mean: null,
    client_w2_id: null,
    created_by: null,
    creation_date: "",
    description: null,
    firm_id: null,
    last_update_date: "",
    last_updated_by: null,
    spouse_contact_cell_phone: null,
    spouse_contact_email_address: null,
    spouse_contact_home_phone: null,
    spouse_contact_work_phone: null,
    spouse_federal_tax_id: null,
    spouse_federal_tax_id_type: "",
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_middle_name: null,
    spouse_w2_flag: "",
    tax_year: null,
    tax_year_description: "",
    w2_box_12_amount_1: null,
    w2_box_12_amount_2: null,
    w2_box_12_amount_3: null,
    w2_box_12_amount_4: null,
    w2_box_12_amount_5: null,
    w2_box_12_amount_6: null,
    w2_box_12_amount_7: null,
    w2_box_12_code_desc1: null,
    w2_box_12_code_desc2: null,
    w2_box_12_code_desc3: null,
    w2_box_12_code_desc4: null,
    w2_box_12_code_desc5: null,
    w2_box_12_code_desc6: null,
    w2_box_12_code_desc7: null,
    w2_box_12_code_mean1: null,
    w2_box_12_code_mean2: null,
    w2_box_12_code_mean3: null,
    w2_box_12_code_mean4: null,
    w2_box_12_code_mean5: null,
    w2_box_12_code_mean6: null,
    w2_box_12_code_mean7: null,
    w2_box_12_lkcd_1: null,
    w2_box_12_lkcd_2: null,
    w2_box_12_lkcd_3: null,
    w2_box_12_lkcd_4: null,
    w2_box_12_lkcd_5: null,
    w2_box_12_lkcd_6: null,
    w2_box_12_lkcd_7: null,
    w2_employer_name: "",
    w2_fed_tax_wh: null,
    w2_fed_tax_wh_pct: null,
    w2_medicare_tax_wh: null,
    w2_medicare_tax_wh_pct: null,
    w2_medicare_wages: null,
    w2_socsec_tax_wh: null,
    w2_socsec_tax_wh_pct: null,
    w2_socsec_wages: null,
    w2_state2_code_desc: null,
    w2_state2_code_mean: null,
    w2_state2_lkcd: null,
    w2_state2_wages: null,
    w2_state2_wages_wh: null,
    w2_state2_wages_wh_pct: null,
    w2_state3_code_desc: null,
    w2_state3_code_mean: null,
    w2_state3_lkcd: null,
    w2_state3_wages: null,
    w2_state3_wages_wh: null,
    w2_state3_wages_wh_pct: null,
    w2_state4_code_desc: null,
    w2_state4_code_mean: null,
    w2_state4_lkcd: null,
    w2_state4_wages: null,
    w2_state4_wages_wh: null,
    w2_state4_wages_wh_pct: null,
    w2_state_code_desc: null,
    w2_state_code_mean: null,
    w2_state_lkcd: "",
    w2_state_wages: null,
    w2_state_wages_wh: null,
    w2_state_wages_wh_pct: null,
    w2_wages: null
    };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
      tax_year: {value: null, matchMode: FilterMatchMode.IN,}
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const userId = localStorage.getItem("taxUserId");

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_w2s_v/?offset=${offset}&limit=${limit}`);
        allData = [...allData, ...response.data.items];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };

  useEffect(() => {
      const fetchClient = async () => {
        setFetchClientFlag(true);
        try {
          let offset = 0;
          let limit = 25;
          let hasMore = true;
          let allData = [];
          let status = null;
          while (hasMore) {
            const response = await getDataApi1(
              `/ztx_firm_clients_v/?offset=${offset}&limit=${limit}`,
            );
            allData = [...allData, ...response.data.items];
            status = response.status;
            hasMore = response.data.hasMore;
            offset = offset + limit;
          }
          if (allData.length > 0) {
            const options = allData.map((item) => ({
              label: item.client_first_name,
              value: item.client_id,
            }));
            setClientNameOptions(options);
            console.log(options);
            setFetchClientFlag(false);
          }
        } catch (err) {
          console.error(err);
          setFetchClientFlag(false);
        }
      };
      fetchClient();
    }, []);
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const numWagesTemplate = (rowData) => {
    return (rowData.w2_wages || rowData.w2_wages === 0) ? numeral(rowData.w2_wages).format('0,0.00') : null;
  };
  const numSecSecWagesTemplate = (rowData) => {
    return (rowData.w2_socsec_wages || rowData.w2_socsec_wages === 0) ? numeral(rowData.w2_socsec_wages).format('0,0.00') : null;
  };
  const numMedicareWagesTemplate = (rowData) => {
    return (rowData.w2_medicare_wages || rowData.w2_medicare_wages === 0) ? numeral(rowData.w2_medicare_wages).format('0,0.00') : null;
  };
  const numFedTaxWHTemplate = (rowData) => {
    return (rowData.w2_fed_tax_wh || rowData.w2_fed_tax_wh === 0) ? numeral(rowData.w2_fed_tax_wh).format('0,0.00') : null;
  };
  const numSecSecWHTemplate = (rowData) => {
    return (rowData.w2_socsec_tax_wh || rowData.w2_socsec_tax_wh === 0) ? numeral(rowData.w2_socsec_tax_wh).format('0,0.00') : null;
  };
  const numMedicareTaxWHTemplate = (rowData) => {
    return (rowData.w2_medicare_tax_wh || rowData.w2_medicare_tax_wh === 0) ? numeral(rowData.w2_medicare_tax_wh).format('0,0.00') : null;
  };
  const numStateWagesTemplate = (rowData) => {
    return (rowData.w2_state_wages || rowData.w2_state_wages === 0) ? numeral(rowData.w2_state_wages).format('0,0.00') : null;
  };
  const numSecSecWagesWHTemplate = (rowData) => {
    return (rowData.w2_state_wages_wh || rowData.w2_state_wages_wh === 0) ? numeral(rowData.w2_state_wages_wh).format('0,0.00') : null;
  };

  const numWages = (row.w2_wages || row.w2_wages === 0) ? numeral(row.w2_wages).format('0,0.00') : null;
  const numSecSecWages = (row.w2_socsec_wages || row.w2_socsec_wages === 0) ? numeral(row.w2_socsec_wages).format('0,0.00') : null;
  const numMedicareWages = (row.w2_medicare_wages || row.w2_medicare_wages === 0) ? numeral(row.w2_medicare_wages).format('0,0.00') : null;
  const numFedTaxWH = (row.w2_fed_tax_wh || row.w2_fed_tax_wh === 0) ? numeral(row.w2_fed_tax_wh).format('0,0.00') : null;
  const numSecSecWH = (row.w2_socsec_tax_wh || row.w2_socsec_tax_wh === 0) ? numeral(row.w2_socsec_tax_wh).format('0,0.00') : null;
  const numMedicareTaxWH = (row.w2_medicare_tax_wh || row.w2_medicare_tax_wh === 0) ? numeral(row.w2_medicare_tax_wh).format('0,0.00') : null;
  const numStateWages = (row.w2_state_wages || row.w2_state_wages === 0) ? numeral(row.w2_state_wages).format('0,0.00') : null;
  const numSecSecWagesWH = (row.w2_state_wages_wh || row.w2_state_wages_wh === 0) ? numeral(row.w2_state_wages_wh).format('0,0.00') : null;

  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showNewProduct = () => {
    setRow(emptyRow);
    setCurrentMode('I');
    setShowProductDialog(true);
  };
  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowProductDialog(true);
}
const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U');
    setShowProductDialog(true);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">W2s Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      W2s
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <Button
        // label="New"
        icon="pi pi-plus"
        className="p-button-success p-button-rounded p-mr-2"
        onClick={showNewProduct}
        tooltip="New"
        tooltipOptions={{ position: "bottom" }}
      />
      
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const editBodyTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-secondary"
            onClick={() => showEditProduct(rowData)}
            tooltip="Edit"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
    };

  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select"
    display="chip" showClear/>
  )

   const saveData = async (currentMode) => {
    if(currentMode === 'I') {
    try {
      const p_param = {
        p_user_id: userId,                                       
        p_client_id: row.client_id,                                                                 
        p_tax_year: row.tax_year,                                                                   
        p_w2_employer_name: row.w2_employer_name, 
        p_w2_wages: row.w2_wages,                                               
        p_w2_socsec_wages: row.w2_socsec_wages, 
        p_spouse_w2_flag: row.spouse_w2_flag,                                  
        p_w2_medicare_wages: row.w2_medicare_wages,                                                         
        p_w2_fed_tax_wh: row.w2_fed_tax_wh,                                   
        p_w2_socsec_tax_wh: row.w2_socsec_tax_wh,  
        p_w2_medicare_tax_wh: row.w2_medicare_tax_wh,  
        p_w2_box_12_lkcd_1: row.w2_box_12_lkcd_1,                                                   
        p_w2_box_12_amount_1: row.w2_box_12_amount_1,                                               
        p_w2_box_12_lkcd_2: row.w2_box_12_lkcd_2,                                                   
        p_w2_box_12_amount_2: row.w2_box_12_amount_2,                                               
        p_w2_box_12_lkcd_3: row.w2_box_12_lkcd_3,                                                   
        p_w2_box_12_amount_3: row.w2_box_12_amount_3,                                               
        p_w2_box_12_lkcd_4: row.w2_box_12_lkcd_4,                                                   
        p_w2_box_12_amount_4: row.w2_box_12_amount_4,                                               
        p_w2_box_12_lkcd_5: row.w2_box_12_lkcd_5,                                                   
        p_w2_box_12_amount_5: row.w2_box_12_amount_5,                                               
        p_w2_box_12_lkcd_6: row.w2_box_12_lkcd_6,                                                   
        p_w2_box_12_amount_6: row.w2_box_12_amount_6,                                               
        p_w2_box_12_lkcd_7: row.w2_box_12_lkcd_7,                                                   
        p_w2_box_12_amount_7: row.w2_box_12_amount_7,                                               
        p_w2_state_lkcd: row.w2_state_lkcd,                                                         
        p_w2_state_wages: row.w2_state_wages,                                                       
        p_w2_state_wages_wh: row.w2_state_wages_wh,                                                 
        p_w2_state2_lkcd: row.w2_state2_lkcd,                                                       
        p_w2_state2_wages: row.w2_state2_wages,                                                     
        p_w2_state2_wages_wh: row.w2_state2_wages_wh,                                               
        p_w2_state3_lkcd: row.w2_state3_lkcd,                                                       
        p_w2_state3_wages: row.w2_state3_wages,                                                     
        p_w2_state3_wages_wh: row.w2_state3_wages_wh,                                               
        p_w2_state4_lkcd: row.w2_state4_lkcd,                                                       
        p_w2_state4_wages: row.w2_state4_wages,                                                     
        p_w2_state4_wages_wh: row.w2_state4_wages_wh,                                               
        p_description: row.description,           
      };
      console.log("Insert p_param: ", p_param);
      const response = await loadApi1(
        p_param,
        "/ztx_client_w2s/v1/",
      );
      console.log(response);
      console.log(response.data);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Inserted",
        });
        const newRow = {
          client_w2_id: response.data.o_client_w2_id,
          ...row,
        };
        setRows((prev) => [...prev, newRow]);
        setShowProductDialog(false);
        setCurrentMode('');
        setRow(emptyRow);
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Inserted",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
        setErrorDialogVisible(true);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  } else if (currentMode === 'U'){

     const p_param = {                                                                              
	        p_user_id: userId,                                       
          p_client_id: row.client_id,  
          p_client_w2_id: row.client_w2_id,                                                               
          p_tax_year: row.tax_year,                                                                   
          p_w2_employer_name: row.w2_employer_name, 
          p_w2_wages: row.w2_wages,     
          p_spouse_w2_flag: row.spouse_w2_flag,                                          
          p_w2_socsec_wages: row.w2_socsec_wages,                                   
          p_w2_medicare_wages: row.w2_medicare_wages,                                                         
          p_w2_fed_tax_wh: row.w2_fed_tax_wh,                                   
          p_w2_socsec_tax_wh: row.w2_socsec_tax_wh,  
          p_w2_medicare_tax_wh: row.w2_medicare_tax_wh,      
          p_w2_state_wages: row.w2_state_wages,  
          p_w2_state_wages_wh: row.w2_state_wages_wh,   
          p_w2_box_12_lkcd_1: row.w2_box_12_lkcd_1,                                                   
          p_w2_box_12_amount_1: row.w2_box_12_amount_1,                                               
          p_w2_box_12_lkcd_2: row.w2_box_12_lkcd_2,                                                   
          p_w2_box_12_amount_2: row.w2_box_12_amount_2,                                               
          p_w2_box_12_lkcd_3: row.w2_box_12_lkcd_3,                                                   
          p_w2_box_12_amount_3: row.w2_box_12_amount_3,                                               
          p_w2_box_12_lkcd_4: row.w2_box_12_lkcd_4,                                                   
          p_w2_box_12_amount_4: row.w2_box_12_amount_4,                                               
          p_w2_box_12_lkcd_5: row.w2_box_12_lkcd_5,                                                   
          p_w2_box_12_amount_5: row.w2_box_12_amount_5,                                               
          p_w2_box_12_lkcd_6: row.w2_box_12_lkcd_6,                                                   
          p_w2_box_12_amount_6: row.w2_box_12_amount_6,                                               
          p_w2_box_12_lkcd_7: row.w2_box_12_lkcd_7,                                                   
          p_w2_box_12_amount_7: row.w2_box_12_amount_7,                                               
          p_w2_state_lkcd: row.w2_state_lkcd,                                                  
          p_w2_state2_lkcd: row.w2_state2_lkcd,                                                       
          p_w2_state2_wages: row.w2_state2_wages,                                                     
          p_w2_state2_wages_wh: row.w2_state2_wages_wh,                                               
          p_w2_state3_lkcd: row.w2_state3_lkcd,                                                       
          p_w2_state3_wages: row.w2_state3_wages,                                                     
          p_w2_state3_wages_wh: row.w2_state3_wages_wh,                                               
          p_w2_state4_lkcd: row.w2_state4_lkcd,                                                       
          p_w2_state4_wages: row.w2_state4_wages,                                                     
          p_w2_state4_wages_wh: row.w2_state4_wages_wh,                                               
          p_description: row.description,                                                                           
    
     };    
   
    console.log("Edit p_param: ", p_param);
    try {
      const response = await saveApi1(
        p_param,
        `/ztx_client_w2s/v1/`,
      );
      console.log(response);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Updated",
        });
        setRows((prev) =>
          prev.map((data) =>
            data.client_w2_id === row.client_w2_id
              ? { ...row }
              : data,
          ),
        );
        setShowProductDialog(false);
        setCurrentMode('');
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Updated",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
      }

      //setRows(response.data);
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  }
  };
  

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">W2s</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_w2_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
        >

          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} filterElement={clientFilterTemplate}></Column>
          <Column field="tax_year" header="Tax Year" filter showFilterMenu={false} filterElement={taxYearFilterTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_employer_name" header="W2 Employer" sortable></Column>
          <Column field="w2_wages" header="Wages" body={numWagesTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_socsec_wages" header="SecSec Wages" body={numSecSecWagesTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_medicare_wages" header="Medicare Wages" body={numMedicareWagesTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_fed_tax_wh" header="Fed Tax WH" body={numFedTaxWHTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_socsec_tax_wh" header="SecSec WH" body={numSecSecWHTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_medicare_tax_wh" header="Medicare Tax WH" body={numMedicareTaxWHTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_state_wages" header="State Wages" body={numStateWagesTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="w2_state_wages_wh" header="SecSec Wages WH" body={numSecSecWagesWHTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="W2s" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="tax_year">Tax Year</label>
                    <div className="box">
                        {row.tax_year}
                    </div>

                <label htmlFor="w2_employer_name">W2 Employer</label>
                    <div className="box">
                        {row.w2_employer_name}
                    </div>

                <label htmlFor="w2_wages">Wages</label>
                    <div className="box">
                        {numWages}
                    </div>
                <label htmlFor="w2_socsec_wages">SecSec Wages</label>
                    <div className="box">
                        {numSecSecWages}
                    </div>

                <label htmlFor="w2_medicare_wages">Medicare Wages</label>
                    <div className="box">
                        {numMedicareWages}
                    </div>

                <label htmlFor="w2_fed_tax_wh">Fed Tax WH</label>
                    <div className="box">
                        {numFedTaxWH}
                    </div>

                <label htmlFor="w2_socsec_tax_wh">SecSec WH</label>
                    <div className="box">
                        {numSecSecWH}
                    </div>
                <label htmlFor="w2_medicare_tax_wh">Medicare Tax WH</label>
                    <div className="box">
                        {numMedicareTaxWH}
                    </div>

                <label htmlFor="w2_state_wages">State Wages</label>
                    <div className="box">
                        {numStateWages}
                    </div>

                <label htmlFor="w2_state_wages_wh">SecSec Wages</label>
                    <div className="box">
                        {numSecSecWagesWH}
                    </div>

            </Dialog> */}

            <Dialog
                // header="Add "
                header={currentMode === 'I' ? "Add W2s" : currentMode === 'U' ? "Update W2s" : currentMode === 'R' ? "View W2s" : "W2s"}
                visible={showproductDialog}
                style={{ width: "40rem" }}
                onHide={() => setShowProductDialog(false)}
              >
                <div className="p-fluid">
                  <div className="grid">
                  <div className="col-12  field">
                    <label>Client</label>
                    <Dropdown
                      value={row.client_id}
                      disabled = {currentMode === 'R' ? true : false}
                      options={clientNameOptions}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Client"
                      onChange={(e) => {
                        const selectedOption = clientNameOptions.find(
                          (option) => option.value === e.value,
                        );
                        setRow({
                          ...row,
                          client_id: e.value,
                          client_first_name: selectedOption?.label || "",
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>Tax Year</label>
                    <InputNumber
                      value={row.tax_year}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={false}
                      onChange={(e) => setRow({ ...row, tax_year: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: "2.5rem" }}>
                      <label>Spouse w2 flag</label>
                      <Checkbox
                        checked={row.spouse_w2_flag === "Y"}
                        disabled = {currentMode === 'R' ? true : false}
                        onChange={(e) =>
                          setRow({
                            ...row,
                            spouse_w2_flag: e.checked ? "Y" : "N",
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-12 field">
                    <label>W2 Employer</label>
                    <InputText
                      value={row.w2_employer_name}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_employer_name: e.target.value })}
                    />
                  </div>
                  <div className="col-12 field">
                    <label>Description</label>
                    <InputTextarea value={row.description} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, description: e.target.value })} rows={5} cols={30}
                    />
                  </div>

                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 1</label>
                    <InputText
                      value={row.w2_box_12_lkcd_1}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_1: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 2</label>
                    <InputText
                      value={row.w2_box_12_lkcd_2}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_2: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 3</label>
                    <InputText
                      value={row.w2_box_12_lkcd_3}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_3: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 4</label>
                    <InputText
                      value={row.w2_box_12_lkcd_4}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_4: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 5</label>
                    <InputText
                      value={row.w2_box_12_lkcd_5}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_5: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 6</label>
                    <InputText
                      value={row.w2_box_12_lkcd_6}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_6: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 Box 12 Lkcd 7</label>
                    <InputText
                      value={row.w2_box_12_lkcd_7}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_box_12_lkcd_7: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 State Lkcd</label>
                    <InputText
                      value={row.w2_state_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_state_lkcd: e.target.value })}
                    />
                  </div>

                  <div className="col-12  field">
                    <label>W2 State2 Lkcd</label>
                    <InputText
                      value={row.w2_state2_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_state2_lkcd: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>W2 State3 Lkcd</label>
                    <InputText
                      value={row.w2_state3_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_state3_lkcd: e.target.value })}
                    />
                  </div>
                 <div className="col-12  field">
                    <label>W2 State4 Lkcd</label>
                    <InputText
                      value={row.w2_state4_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, w2_state4_lkcd: e.target.value })}
                    />
                  </div>

                  
                  <div className="col-12 md:col-6 field">
                    <label>Wages</label>
                    <InputNumber
                      value={row.w2_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_wages: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>SecSec Wages</label>
                    <InputNumber
                      value={row.w2_socsec_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_socsec_wages: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>Medicare Wages</label>
                    <InputNumber
                      value={row.w2_medicare_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_medicare_wages: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>Fed Tax WH</label>
                    <InputNumber
                      value={row.w2_fed_tax_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_fed_tax_wh: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>SecSec WH</label>
                    <InputNumber
                      value={row.w2_socsec_tax_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_socsec_tax_wh: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>Medicare Tax WH</label>
                    <InputNumber
                      value={row.w2_medicare_tax_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_medicare_tax_wh: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>State Wages</label>
                    <InputNumber
                      value={row.w2_state_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state_wages: e.value })}
                    />
                  </div>

                  <div className="col-12 md:col-6 field">
                    <label>SecSec Wages</label>
                    <InputNumber
                      value={row.w2_state_wages_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state_wages_wh: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 1</label>
                    <InputNumber
                      value={row.w2_box_12_amount_1}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_1: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 2</label>
                    <InputNumber
                      value={row.w2_box_12_amount_2}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_2: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 3</label>
                    <InputNumber
                      value={row.w2_box_12_amount_3}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_3: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 4</label>
                    <InputNumber
                      value={row.w2_box_12_amount_4}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_4: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 5</label>
                    <InputNumber
                      value={row.w2_box_12_amount_5}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_5: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 6</label>
                    <InputNumber
                      value={row.w2_box_12_amount_6}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_6: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>Box 12 Amount 7</label>
                    <InputNumber
                      value={row.w2_box_12_amount_7}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_box_12_amount_7: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>State2 Wages</label>
                    <InputNumber
                      value={row.w2_state2_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state2_wages: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>State2 Wages Wh</label>
                    <InputNumber
                      value={row.w2_state2_wages_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state_wages_wh: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>State3 Wages</label>
                    <InputNumber
                      value={row.w2_state3_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state3_wages: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>State3 Wages Wh</label>
                    <InputNumber
                      value={row.w2_state3_wages_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state3_wages_wh: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>State4 Wages</label>
                    <InputNumber
                      value={row.w2_state4_wages}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state4_wages: e.value })}
                    />
                  </div>
                   <div className="col-12 md:col-6 field">
                    <label>State4 Wages Wh</label>
                    <InputNumber
                      value={row.w2_state4_wages_wh}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, w2_state4_wages_wh: e.value })}
                    />
                  </div>
                  </div>
                  <div
                    style={{
                      marginTop: "1rem",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "0.5rem",
                    }}
                  >
                    <Button
                      label="Cancel"
                      icon="pi pi-times"
                      severity="secondary"
                      onClick={() => {
                        setShowProductDialog(false);
                        setRow(emptyRow);
                        setCurrentMode('');
                      }}
                    />
                    <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                  </div>
                </div>
              </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}}
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default W2s;